module.exports = __webpack_public_path__ + "img/noNews.5f227afa.png";